import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

const Motorcycle = (props) => {
  const intl = useIntl();

  return (
    <svg
      role="img"
      focusable="false"
      aria-labelledby="svgMotocycleTitle"
      aria-describedby="svgMotorcycleDescription"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 900 900"
    >
      <title id="svgMotocycleTitle">
        <FormattedMessage id="image.coloring-book.motorcycle" />
      </title>
      <desc id="svgMotorcycleDescription">
        {intl.formatMessage({ id: 'image.coloring-book.motorcycle-description' })}
      </desc>
      <g id="MotorcycleLayer" data-name="Layer">
        <path
          onClick={() => props.onFill(0)}
          fill={props.colors[0]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M196.66,486.58a86.55,86.55,0,1,1-17.6-13.37l19.48-27.5a120.83,120.83,0,1,0,17.72,13.2Z"
        />
        <path
          onClick={() => props.onFill(1)}
          fill={props.colors[1]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M317.47,311.24c4.21-.48,25.41-3.18,35-9.93,8.73-6.17,15.25-15.55,15.64-20.11.06-.71-.07-1.05-.15-1.12-2.88-2.88-12-13-14.52-15.77-7.87.49-26.32,2.88-31,9-5.39,7-14.73,23.75-17.59,28.93l11.65,8.25Z"
        />
        <path
          onClick={() => props.onFill(2)}
          fill={props.colors[2]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M504.66,593.55c3.85-.07,8.22-.14,12.55-.6,2-.22,3.27-.78,3.71-1.67,1.42-2.86-3-10.23-6.91-16.73-1-1.74-2.13-3.54-3.14-5.31-5.4-9.44-1.41-14.84,2.81-20.56a42.27,42.27,0,0,0,5.4-8.77c2.4-5.68,1.16-11.55.06-16.72-1-4.6-1.91-9,0-12.36,2-4.47-6.95-49.64-14-80.82-5.72-3.24-8.56-6-9-8.41a12.61,12.61,0,0,1-.16-3.55,48.69,48.69,0,0,1-9.36.8c-17.43,0-43.79-6.23-72.92-13.33.08,2.91-1.59,6-5,9.13-5.43,5-18.94,1-40.51-6-13.16-4.26-26.77-8.66-36.42-9.22-3.39-.19-5.88.63-7.59,2.52-5.17,5.7-2.92,20.2-1.27,30.79.95,6.13,1.71,11,1.08,13.7-.88,3.82-2.83,4.88-4.31,5.09a4.2,4.2,0,0,1-.72.06,7.39,7.39,0,0,1-4.44-1.84c10.11,47.3,30.09,131.81,39.84,142.54l.75.82c12.39,13.64,16.13,17.76,29.62,20.21,12.88,2.34,88.35-7.91,100.69-9.62-.13-1.7,1.34-3.18,2.56-4.41a9.69,9.69,0,0,0,1.7-2C491.06,593.78,496.47,593.69,504.66,593.55ZM458,535.39a39.4,39.4,0,1,1-71.28-2.28c-3.38-3.51-16.21-17-28.37-31.63-29.13-35.2-26-43.12-25-45.73,6-15.37,15.89-22.6,29.87-29.29A31.17,31.17,0,0,1,387.45,425a31.51,31.51,0,0,1,17.83,16.86c5,11,11.4,29.12,14.78,39.07a251,251,0,0,1,7.1-25.92c7.73-22.73,16.55-33.95,26.3-33.34,33.62,2.1,42.55,14.44,46.34,23.54C506.24,460.67,466.39,522.65,458,535.39Z"
        />
        <path
          onClick={() => props.onFill(3)}
          fill={props.colors[3]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M273.51,328.53c0-14.34-10.72-24.9-28-27.55a18.83,18.83,0,0,0-2.88-.24,9,9,0,0,0-6.16,2c-5,4.26-4.94,15.15-4.92,25.67v2.09c0,17.63,3.83,25,13.2,25.56a26.66,26.66,0,0,0,20-7.4A27.89,27.89,0,0,0,273.51,328.53Z"
        />
        <path
          onClick={() => props.onFill(4)}
          fill={props.colors[4]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M314.15,313.79l-11.5-8.15-98.42,139-2.31,3.27-19.44,27.43-2.32,3.29-50.77,69.91a6.1,6.1,0,0,0,1.45,8.51l1.54,1.09a6.12,6.12,0,0,0,8.51-1.45l50.5-69.54,2.33-3.28,19.5-27.54,2.32-3.28,77.33-109.17Z"
        />
        <path
          onClick={() => props.onFill(5)}
          fill={props.colors[5]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M453.21,425.67h-.48c-9.86,0-17.85,19.1-21.77,30.61A253.4,253.4,0,0,0,422.5,489l-1.4,7.84-2.48-7.57c-.09-.3-9.89-30.26-17-45.72a27.55,27.55,0,0,0-15.56-14.77,27.17,27.17,0,0,0-21.13,1.3c-13.11,6.27-22.34,13-27.87,27.14-3.87,9.88,29,48.84,51.73,72.3a39.36,39.36,0,0,1,67.11,1.75c4.09-6.34,13-20.42,21.42-35.42,19.56-34.93,20.15-45.75,18.76-49.09C490.66,433.69,477.43,427.19,453.21,425.67Z"
        />
        <path
          onClick={() => props.onFill(6)}
          fill={props.colors[6]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M319.15,447.57c.22,0,.67-.6,1-2,.46-2-.32-6.93-1.13-12.19-1.87-12-4.2-27,2.26-34.09,2.54-2.8,6.16-4.08,10.78-3.82,10.16.58,24,5.07,37.42,9.41,15.27,4.94,32.57,10.55,36.57,6.87,2.61-2.41,3.89-4.6,3.72-6.32a3.12,3.12,0,0,0-.26-.91l-.39-.1c-10.89-2.66-22.15-5.41-33-7.84-16.57-3.72-27.89-11.1-33.66-21.93-5-9.37-5.15-20.07-3.35-29.86-3.49.52-9.92.8-15.46-2.72s-10.19-12-12.45-16.75l-15.08,20.88L271.7,380.65c4.08,5.32,18.1,24,29.17,43.35C314.55,447.94,319,447.6,319.15,447.57Z"
        />
        <path
          onClick={() => props.onFill(7)}
          fill={props.colors[7]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M421.84,515.57a35.4,35.4,0,1,0,35.4,35.4A35.44,35.44,0,0,0,421.84,515.57Zm0,47.32A11.92,11.92,0,1,1,433.75,551,11.94,11.94,0,0,1,421.84,562.89Z"
        />
        <path
          onClick={() => props.onFill(8)}
          fill={props.colors[8]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M176.72,476.51a83,83,0,1,0,17.6,13.37L144.15,559a10.1,10.1,0,0,1-14.08,2.4l-1.54-1.09a10.09,10.09,0,0,1-2.4-14.08Z"
        />
        <path
          onClick={() => props.onFill(9)}
          fill={props.colors[9]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M782,376.53c16,5.13,33.59,10,36.48,9.52,7-1.17,11.51-2.15,13.64-2.65-.13-7.43-1.94-22.41-9.45-22.69-9.63-.35-33.22,7.36-40.16,9.72a12.55,12.55,0,0,1,.25,3.24A7.75,7.75,0,0,1,782,376.53Z"
        />
        <path
          onClick={() => props.onFill(10)}
          fill={props.colors[10]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M673.84,379.77a39.91,39.91,0,0,1,6,9.59,24,24,0,0,1,1.87,6.59,20.76,20.76,0,0,0,8.17,4.59c3.15.9,11.53-4,18.91-8.3,4.71-2.75,9.58-5.6,14.25-7.78,7.35-3.43,20.88-4.47,32.82-5.39,8.63-.67,18.53,0,20.89-2.84,1.21-1.44,1.35-5.57,1.17-7.45-.5-5.18-5.93-10.56-8.57-13-3.1-2.82-29.91-.36-49.48,1.44-6.53.6-13.28,1.22-19.45,1.7-20.82,1.62-32.74,9-37.09,12.28A29.16,29.16,0,0,1,673.84,379.77Z"
        />
        <path
          onClick={() => props.onFill(11)}
          fill={props.colors[11]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M409.38,286.24c0,2.05.42,4.26,3.62,6.28a8.09,8.09,0,0,0,5.41.68,7,7,0,0,0,5.41-7c.07-1.93-.5-4.31-3.49-6.49a5.4,5.4,0,0,0-3.74-1.06A7.67,7.67,0,0,0,409.38,286.24Z"
        />
        <path
          onClick={() => props.onFill(12)}
          fill={props.colors[12]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M354.29,258.18l51.93,30a12.64,12.64,0,0,1-.16-2,11.62,11.62,0,0,1,6.11-10.44l-51-29.47a5.94,5.94,0,0,0-8.1,2.18l-.93,1.59a5.93,5.93,0,0,0-.59,4.51A5.87,5.87,0,0,0,354.29,258.18Z"
        />
        <path
          onClick={() => props.onFill(13)}
          fill={props.colors[13]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M530.31,415.15c1.86,2.15,20.88,9.58,53.64,19.63,31,9.52,52.65,14.72,55.64,14.26,6.86-1.08,11.9-13.74,14.32-19.82l.33-.82c2.11-5.29,6.86-9.81,13.43-16.07,2.14-2,4.57-4.36,7.13-6.91,8.6-8.6-3.89-22.93-4-23.07l-.14-.18c-.41-.58-10.13-14.15-24.08-6.4-8.53,4.75-14.2,10.6-19.2,15.76-4,4.13-7.79,8-12.31,10.5-10.79,5.88-47.18-5.79-57.81-10.89-4.35-2.09-11.91-3.71-19.33-3.71a33.79,33.79,0,0,0-13.41,2.38c-3.46,1.55-5.64,3.79-6.47,6.64-2.37,8.15,1.14,10.45,6,13.64A28.71,28.71,0,0,1,530.31,415.15Z"
        />
        <path
          onClick={() => props.onFill(14)}
          fill={props.colors[14]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M377,392.63c10.84,2.44,22.06,5.18,32.91,7.83l.49-.81a7.75,7.75,0,0,1,1.52,1.3c42.17,10.3,85.2,20.62,91.47,8.47h0c6.46-12.52-20.77-37.12-66.81-72.75-24.76-19.16-45-23.22-57.78-23.22A47.86,47.86,0,0,0,366.16,315c-9.2,2.56-15.88,8.09-18.79,15.58-4.59,11.8-8.56,28.7-1.38,42.16C351.18,382.48,361.62,389.18,377,392.63Z"
        />
        <path
          onClick={() => props.onFill(15)}
          fill={props.colors[15]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M421.84,543.06a7.92,7.92,0,1,0,7.91,7.91A7.92,7.92,0,0,0,421.84,543.06Z"
        />
        <path
          onClick={() => props.onFill(16)}
          fill={props.colors[16]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M645.42,486,537.88,443.89q-6.15-2.22-11.31-4.24c3.11,11.6,11.66,44.55,11.66,56,0,1,0,1.88,0,2.72,0,4.38,0,7.55.76,8.32s4.3.66,7.67.53c.38,0,.85,0,1.41,0,4.41,0,14.48.42,27.83,1,15.32.64,39.19,1.64,59.36,2l4.16.07c16.73.23,30.16-.06,32.65-1.47.54-.8,5.1-9.4,5.47-10.26l-28.35-11.09Z"
        />
        <path
          onClick={() => props.onFill(17)}
          fill={props.colors[17]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M681.83,504.19a2.67,2.67,0,0,0-1.17-.27,2.79,2.79,0,0,0-.9.15,2.3,2.3,0,0,0-.5.24c-.53,1.05-1.12,2.17-1.77,3.31a2.7,2.7,0,0,0,.14.88A2.67,2.67,0,0,0,679,510l.65.31,77.06,37.16a2.73,2.73,0,0,0,3.61-1.26l.47-1a2.66,2.66,0,0,0,.12-2.07,2.71,2.71,0,0,0-1.38-1.54l-76.85-37Z"
        />
        <path
          onClick={() => props.onFill(18)}
          fill={props.colors[18]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M746.46,426.81c1.7-.56,3.42-1,5.16-1.42a120.54,120.54,0,0,0-100.27,58.28l28,11.22c1.77-3.22,6-12.06,7.6-26.17C688.74,453,708.21,439.33,746.46,426.81Z"
        />
        <path
          onClick={() => props.onFill(19)}
          fill={props.colors[19]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M688.07,602.79l.69-.26,4-1.5,58.83-22a7.78,7.78,0,0,0,5-8.26l-70,20.5H576.88a11.54,11.54,0,0,0-11.53,11.53v.65H684.52A10,10,0,0,0,688.07,602.79Z"
        />
        <rect
          onClick={() => props.onFill(20)}
          fill={props.colors[20]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          x="545.92"
          y="514.7"
          width="34.06"
          height="29.68"
          rx="13.09"
        />
        <path
          onClick={() => props.onFill(21)}
          fill={props.colors[21]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M877.49,407.59C875,402.29,849.85,394.7,819,390a5.54,5.54,0,0,1-.75.05c-6.92,0-32.41-8.08-39.49-10.37-3.71,1.82-11.19,2.49-22.6,3.37-11.6.89-24.75,1.9-31.44,5-4.51,2.1-9.29,4.9-13.92,7.6-8.43,4.92-15.31,8.94-20.11,8.94a6.91,6.91,0,0,1-1.92-.25,24.36,24.36,0,0,1-7.21-3.43,13.94,13.94,0,0,1-4,7.3c-2.59,2.59-5,4.92-7.2,7-6.21,5.91-10.69,10.18-12.48,14.66l-.33.81c-2.9,7.29-8.3,20.85-17.4,22.29a5.34,5.34,0,0,1-.86.06c-7.45,0-38.63-8.94-56.58-14.45-11.52-3.53-48.43-15.11-54.88-20.26-2.48-.41-12.78-2-18.67-1.64-1.34.09-2.63.09-3.77.1-2.23,0-4.53,0-5.13.74-.19.22-.58,1-.18,3.4.1.61,1.58,4,20.43,12l0-.12,19.55,7.65c5.41,1.95,10.29,3.62,13.75,4.81l2.28.78c8.25,2.85,57.34,22.43,91.47,36.1A124.46,124.46,0,0,1,787.13,425.7a114.78,114.78,0,0,1,16.44,4.4l1.16-.33a36.66,36.66,0,0,1,13.87-2.63c.54,0,1.06,0,1.57,0s1.14,0,1.71,0c4.25,0,6.49,1.72,8.46,3.23,2.58,2,5,3.83,13.09,2.49C850.14,431.74,874.47,411.65,877.49,407.59Z"
        />
        <path
          onClick={() => props.onFill(22)}
          fill={props.colors[22]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M818.6,460.39c9.17,0,11.71-2.48,12.4-7.57a38.14,38.14,0,0,0,.26-4.93v-.81c0-9.19-.81-15.35-11.12-15.89-14.37.17-16.29,3.25-17.7,4.12-4.31,2.66-7,6.36-7,10.46C795.45,453.83,805.84,460.39,818.6,460.39Z"
        />
        <path
          onClick={() => props.onFill(23)}
          fill={props.colors[23]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M818.6,464.39c-15,0-27.15-8.36-27.15-18.62,0-4.68,2.53-9,6.7-12.23q-5.46-2.13-11.17-3.73c-11-2.18-26-3.54-39.28.8-36.1,11.82-55.21,24.8-56.81,38.57-1.75,15.05-6.21,24.32-8.15,27.78a86.88,86.88,0,1,1,8.91,108.76l-2.18.82a14.2,14.2,0,0,1-5,.89H651A120.44,120.44,0,1,0,834.41,455.75C833,461,829,464.39,818.6,464.39Z"
        />
        <path
          onClick={() => props.onFill(24)}
          fill={props.colors[24]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M757.76,579.47A33.71,33.71,0,1,0,730.11,523l31.16,15a6.7,6.7,0,0,1,3.13,9l-.48,1a6.65,6.65,0,0,1-3.83,3.42,6.64,6.64,0,0,1-5.12-.29h0L720.8,534.63a9.69,9.69,0,0,0,1.92,1A33.68,33.68,0,0,0,734.78,573l24.45-7.16.66,1.73a11.82,11.82,0,0,1-2.13,11.93Z"
        />
        <path
          onClick={() => props.onFill(25)}
          fill={props.colors[25]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M678.18,587.25A86.78,86.78,0,0,1,674.51,512c-1.54,1.15-6.22,2.31-26.54,2.31q-4.35,0-9.72-.08a120.61,120.61,0,0,0,3.13,73Z"
        />
        <path
          onClick={() => props.onFill(26)}
          fill={props.colors[26]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M754.51,628.7a82.87,82.87,0,1,0-69.74-127.54l40.72,19.64a38.64,38.64,0,1,1,23.83,63.34l-53.57,20.05A82.61,82.61,0,0,0,754.51,628.7Z"
        />
        <path
          onClick={() => props.onFill(27)}
          fill={props.colors[27]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M594.65,537.92c2.65-.88,7-1.21,12.1-1.59,6.16-.46,16.46-1.23,17.87-3.64,2-3.41,3.09-13.14,3.51-18.65-17.34-.41-36.51-1.22-52.41-1.88l-2.13-.09A17.11,17.11,0,0,1,584,527.78v3.51a17.11,17.11,0,0,1-17.09,17.09H559a17.11,17.11,0,0,1-17.09-17.09v-3.51a17.1,17.1,0,0,1,12.59-16.46c-3.72-.12-6.42-.17-7.7-.13-5.63.22-8.66.25-10.61-1.64s-2-5.05-2-11.22c0-.84,0-1.73,0-2.7,0-12-10.37-50.72-12.3-57.83-4.74-1.92-8.76-3.7-12.12-5.35,1.5,6.77,4.57,20.82,7.39,35.13,8,40.76,6.22,43.89,5.46,45.23-1.2,2.09-.46,5.54.39,9.54,1.16,5.47,2.61,12.27-.29,19.12a46.26,46.26,0,0,1-5.86,9.59c-4,5.43-6.66,9-2.56,16.2,1,1.73,2.06,3.51,3.1,5.23,5.08,8.45,9.46,15.75,7.06,20.57-1.09,2.19-3.4,3.49-6.87,3.86-4.5.49-9,.56-12.9.63-4.4.07-10.43.18-11.27,1.2a10.49,10.49,0,0,1-2.59,3.36c-.26.26-.59.59-.86.89,1.15.26,3.74.56,9.43.43,6-.13,12.52.21,18.84.53,14.55.73,29.6,1.5,36.44-3.63,5.09-3.82,13.79-19.92,21.46-34.13C586.31,547.44,591.11,539.1,594.65,537.92Z"
        />
        <path
          onClick={() => props.onFill(28)}
          fill={props.colors[28]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M686,587.25l43.07-12.61a38.53,38.53,0,0,1-10.79-41.23L678,514a82.63,82.63,0,0,0,4.77,73.25Z"
        />
        <path
          onClick={() => props.onFill(29)}
          fill={props.colors[29]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M634.13,514.17l-2,0c-.36,4.89-1.44,16.07-4.07,20.57-2.29,3.93-9.81,4.78-21,5.62-4.61.34-9,.67-11.13,1.39-2.53,1-10.45,15.69-16.22,26.39-4.35,8-8.77,16.24-12.83,22.82a15.51,15.51,0,0,1,10-3.67h60.25a124.55,124.55,0,0,1-3-73.08Z"
        />
        <path
          onClick={() => props.onFill(30)}
          fill={props.colors[30]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M844.08,436.8c8.22-1.37,33.59-22.43,36.85-27.15a3.06,3.06,0,0,0,.66-2.33c-.69-3.45-4.81-8.81-32.49-15.47-6.73-1.62-13.44-3-18.77-4,2.82-.6,4.22-1,4.33-1l1.45-.39,0-1.51c0-1.13.32-27.77-13.3-28.27-10.38-.4-34.18,7.39-41.47,9.87a42.35,42.35,0,0,0-9.31-13.73c-4.19-3.81-22.69-2.33-52.54.41-6.51.6-13.25,1.22-19.39,1.7-26.71,2.09-39.42,13.06-41.28,14.8a20.2,20.2,0,0,0-14.22,2.51c-9.06,5-14.94,11.1-20.13,16.46-4,4.08-7.37,7.6-11.35,9.78-8.46,4.61-42.38-5.33-54.17-11-8.93-4.29-26-5.9-36.1-1.37-4.59,2-7.51,5.14-8.68,9.18-3.19,11,2.55,14.76,7.62,18.09h0a78.41,78.41,0,0,0-12.83-.72c-1.05.07-2.05.08-3,.08a10.7,10.7,0,0,0,1-1.54C514.8,396,490.23,373.14,439,333.51c-25.54-19.77-53.19-28.13-73.94-22.37-10.45,2.9-18.07,9.28-21.45,18a91.57,91.57,0,0,0-3.62,11.4c-2,.44-8.78,1.59-14.22-1.87-5.73-3.64-10.78-14.51-12-17.39l4.29-6.05c4.77-.54,26.33-3.31,36.7-10.64,9-6.35,16.77-16.69,17.32-23a5.17,5.17,0,0,0-1.31-4.29c-1.8-1.8-6.26-6.67-9.86-10.63,0,0,49.35,27.85,51.9,28.9a10.79,10.79,0,0,0,13-3.91,10,10,0,0,0-2.44-13.46c-2.25-1.61-60.26-35.31-60.26-35.31a9.94,9.94,0,0,0-13.57,3.64l-.92,1.59a10,10,0,0,0,2,12.43c-7.84.67-25.8,3-31.48,10.38-6.42,8.36-17.73,29.09-18.73,30.91l-23.72,33.49a30.57,30.57,0,0,0,.76-6.75c0-16.21-12.31-28.57-31.36-31.5-5.15-.8-9.27.1-12.26,2.67-6.36,5.47-6.34,17.29-6.31,28.72v2.08c0,13.32,1.93,28.72,17,29.55.58,0,1.15.05,1.73.05a30.44,30.44,0,0,0,16.19-4.66l-61.63,87a124.88,124.88,0,1,0,17.73,13.19l50.69-71.56A415.34,415.34,0,0,1,297.4,426c5.53,9.67,12.24,19.76,12.24,19.76,1.16,5.49,28.48,134.56,41.82,149.23l.75.82c12.75,14,17,18.76,31.87,21.45a37.61,37.61,0,0,0,6.31.39c24.47,0,94.07-9.76,97.34-10.22l-.14-1c1.83.8,5.25,1.17,11.94,1,5.83-.12,12.3.2,18.55.52,5.44.28,10.78.55,15.77.55,9.65,0,18-1,23.27-5a27,27,0,0,0,4.94-5.4,15.54,15.54,0,0,0-.71,4.65v4.65h85A124.44,124.44,0,1,0,835.15,451.08c.08-1.28.11-2.61.11-4a36.69,36.69,0,0,0-1-10.25A24.76,24.76,0,0,0,844.08,436.8Zm-61.56-66.37c6.94-2.36,30.53-10.07,40.16-9.72,7.51.28,9.32,15.26,9.45,22.69-2.13.5-6.61,1.48-13.64,2.65-2.89.49-20.44-4.39-36.48-9.52a7.75,7.75,0,0,0,.76-2.86A12.55,12.55,0,0,0,782.52,370.43ZM700.43,359c6.17-.48,12.92-1.1,19.45-1.7,19.57-1.8,46.38-4.26,49.48-1.44,2.64,2.4,8.07,7.78,8.57,13,.18,1.88,0,6-1.17,7.45-2.36,2.81-12.26,2.17-20.89,2.84-11.94.92-25.47,2-32.82,5.39-4.67,2.18-9.54,5-14.25,7.78-7.38,4.31-15.76,9.2-18.91,8.3a20.76,20.76,0,0,1-8.17-4.59,24,24,0,0,0-1.87-6.59,39.91,39.91,0,0,0-6-9.59,29.16,29.16,0,0,0-10.5-8.53C667.69,368,679.61,360.58,700.43,359ZM518,396.45c.83-2.85,3-5.09,6.47-6.64a33.79,33.79,0,0,1,13.41-2.38c7.42,0,15,1.62,19.33,3.71,10.63,5.1,47,16.77,57.81,10.89,4.52-2.47,8.3-6.37,12.31-10.5,5-5.16,10.67-11,19.2-15.76,14-7.75,23.67,5.82,24.08,6.4l.14.18c.13.14,12.62,14.47,4,23.07-2.56,2.55-5,4.87-7.13,6.91-6.57,6.26-11.32,10.78-13.43,16.07l-.33.82c-2.42,6.08-7.46,18.74-14.32,19.82-3,.46-24.59-4.74-55.64-14.26-32.76-10-51.78-17.48-53.64-19.63a28.71,28.71,0,0,0-6.3-5.06C519.17,406.9,515.66,404.6,518,396.45ZM347.37,330.57c2.91-7.49,9.59-13,18.79-15.58a47.86,47.86,0,0,1,12.64-1.54c12.74,0,33,4.06,57.78,23.22,46,35.63,73.27,60.23,66.81,72.75h0c-6.27,12.15-49.3,1.83-91.47-8.47a7.75,7.75,0,0,0-1.52-1.3l-.49.81c-10.85-2.65-22.07-5.39-32.91-7.83-15.38-3.45-25.82-10.15-31-19.9C338.81,359.27,342.78,342.37,347.37,330.57Zm73-50.82c3,2.18,3.56,4.56,3.49,6.49a7,7,0,0,1-5.41,7,8.09,8.09,0,0,1-5.41-.68c-3.2-2-3.62-4.23-3.62-6.28a7.67,7.67,0,0,1,7.21-7.55A5.4,5.4,0,0,1,420.33,279.75Zm-68.22-29.68.93-1.59a5.94,5.94,0,0,1,8.1-2.18l51,29.47a11.62,11.62,0,0,0-6.11,10.44,12.64,12.64,0,0,0,.16,2l-51.93-30a5.87,5.87,0,0,1-2.77-3.6A5.93,5.93,0,0,1,352.11,250.07Zm-29.74,23.25c4.72-6.13,23.17-8.52,31-9,2.53,2.8,11.64,12.89,14.52,15.77.08.07.21.41.15,1.12-.39,4.56-6.91,13.94-15.64,20.11-9.56,6.75-30.76,9.45-35,9.93l-1-.74-11.65-8.25C307.64,297.07,317,280.33,322.37,273.32Zm-77.59,82.74c-9.37-.52-13.2-7.93-13.2-25.56v-2.09c0-10.52-.05-21.41,4.92-25.67a9,9,0,0,1,6.16-2,18.83,18.83,0,0,1,2.88.24c17.25,2.65,28,13.21,28,27.55a27.89,27.89,0,0,1-8.78,20.13A26.66,26.66,0,0,1,244.78,356.06Zm11.57,192.51a120.57,120.57,0,1,1-57.81-102.86l-19.48,27.5a87.21,87.21,0,1,0,17.6,13.37l19.6-27.67A120.23,120.23,0,0,1,256.35,548.57Zm-131.94,5.15a10.06,10.06,0,0,0,4.12,6.54l1.54,1.09a10.1,10.1,0,0,0,14.08-2.4l50.17-69.07a83,83,0,1,1-17.6-13.37l-50.59,69.67A10.06,10.06,0,0,0,124.41,553.72ZM215.54,453l-2.32,3.28-19.5,27.54-2.33,3.28-50.5,69.54a6.12,6.12,0,0,1-8.51,1.45L130.84,557a6.1,6.1,0,0,1-1.45-8.51l50.77-69.91,2.32-3.29,19.44-27.43,2.31-3.27,98.42-138.95,11.5,8.15-21.28,30Zm85.33-29c-11.07-19.39-25.09-38-29.17-43.35l24.42-34.49,15.08-20.88c2.26,4.7,6.91,13.22,12.45,16.75s12,3.24,15.46,2.72c-1.8,9.79-1.65,20.49,3.35,29.86,5.77,10.83,17.09,18.21,33.66,21.93,10.85,2.43,22.11,5.18,33,7.84l.39.1a3.12,3.12,0,0,1,.26.91c.17,1.72-1.11,3.91-3.72,6.32-4,3.68-21.3-1.93-36.57-6.87-13.4-4.34-27.26-8.83-37.42-9.41-4.62-.26-8.24,1-10.78,3.82-6.46,7.12-4.13,22.08-2.26,34.09.81,5.26,1.59,10.22,1.13,12.19-.33,1.44-.78,2-1,2S314.55,447.94,300.87,424ZM488,599.28c-1.22,1.23-2.69,2.71-2.56,4.41-12.34,1.71-87.81,12-100.69,9.62-13.49-2.45-17.23-6.57-29.62-20.21l-.75-.82c-9.75-10.73-29.73-95.24-39.84-142.54a7.39,7.39,0,0,0,4.44,1.84,4.2,4.2,0,0,0,.72-.06c1.48-.21,3.43-1.27,4.31-5.09.63-2.72-.13-7.57-1.08-13.7-1.65-10.59-3.9-25.09,1.27-30.79,1.71-1.89,4.2-2.71,7.59-2.52,9.65.56,23.26,5,36.42,9.22,21.57,7,35.08,11,40.51,6,3.41-3.16,5.08-6.22,5-9.13,29.13,7.1,55.49,13.33,72.92,13.33a48.69,48.69,0,0,0,9.36-.8,12.61,12.61,0,0,0,.16,3.55c.41,2.44,3.25,5.17,9,8.41,7.06,31.18,16,76.35,14,80.82-1.95,3.41-1,7.76,0,12.36,1.1,5.17,2.34,11-.06,16.72a42.27,42.27,0,0,1-5.4,8.77c-4.22,5.72-8.21,11.12-2.81,20.56,1,1.77,2.09,3.57,3.14,5.31,3.91,6.5,8.33,13.87,6.91,16.73-.44.89-1.69,1.45-3.71,1.67-4.33.46-8.7.53-12.55.6-8.19.14-13.6.23-14.92,3.75A9.69,9.69,0,0,1,488,599.28Zm66.68,1.05c-6.84,5.13-21.89,4.36-36.44,3.63-6.32-.32-12.84-.66-18.84-.53-5.69.13-8.28-.17-9.43-.43.27-.3.6-.63.86-.89a10.49,10.49,0,0,0,2.59-3.36c.84-1,6.87-1.13,11.27-1.2,3.94-.07,8.4-.14,12.9-.63,3.47-.37,5.78-1.67,6.87-3.86,2.4-4.82-2-12.12-7.06-20.57-1-1.72-2.11-3.5-3.1-5.23-4.1-7.18-1.45-10.77,2.56-16.2a46.26,46.26,0,0,0,5.86-9.59c2.9-6.85,1.45-13.65.29-19.12-.85-4-1.59-7.45-.39-9.54.76-1.34,2.55-4.47-5.46-45.23-2.82-14.31-5.89-28.36-7.39-35.13,3.36,1.65,7.38,3.43,12.12,5.35,1.93,7.11,12.3,45.86,12.3,57.83,0,1,0,1.86,0,2.7,0,6.17,0,9.26,2,11.22s5,1.86,10.61,1.64c1.28,0,4,0,7.7.13a17.1,17.1,0,0,0-12.59,16.46v3.51A17.11,17.11,0,0,0,559,548.38h7.88A17.11,17.11,0,0,0,584,531.29v-3.51a17.11,17.11,0,0,0-10.39-15.71l2.13.09c15.9.66,35.07,1.47,52.41,1.88-.42,5.51-1.52,15.24-3.51,18.65-1.41,2.41-11.71,3.18-17.87,3.64-5.07.38-9.45.71-12.1,1.59-3.54,1.18-8.34,9.52-18.47,28.28C568.51,580.41,559.81,596.51,554.72,600.33Zm205.17-32.79-.66-1.73L734.78,573a33.68,33.68,0,0,1-12.06-37.3,9.69,9.69,0,0,1-1.92-1L755,551.11h0a6.64,6.64,0,0,0,5.12.29,6.65,6.65,0,0,0,3.83-3.42l.48-1a6.7,6.7,0,0,0-3.13-9l-31.16-15a33.7,33.7,0,1,1,27.65,56.45,11.82,11.82,0,0,0,2.13-11.93ZM634,545.83a120.29,120.29,0,0,1,4.21-31.6q5.37.07,9.72.08c20.32,0,25-1.16,26.54-2.31a86.78,86.78,0,0,0,3.67,75.25h-36.8A119.79,119.79,0,0,1,634,545.83Zm3.09,41.42H576.88a15.51,15.51,0,0,0-10,3.67c4.06-6.58,8.48-14.77,12.83-22.82,5.77-10.7,13.69-25.35,16.22-26.39,2.17-.72,6.52-1.05,11.13-1.39,11.21-.84,18.73-1.69,21-5.62,2.63-4.5,3.71-15.68,4.07-20.57l2,0a124.55,124.55,0,0,0,3,73.08Zm34.52-41.42A82.35,82.35,0,0,1,678,514l40.25,19.41a38.53,38.53,0,0,0,10.79,41.23L686,587.25h-3.2A82.35,82.35,0,0,1,671.65,545.83Zm77.67,38.31a38.65,38.65,0,1,0-23.83-63.34l-40.72-19.64a82.88,82.88,0,1,1,11,103Zm10.21-42.49a2.71,2.71,0,0,1,1.38,1.54,2.66,2.66,0,0,1-.12,2.07l-.47,1a2.73,2.73,0,0,1-3.61,1.26l-77.06-37.16L679,510a2.67,2.67,0,0,1-1.37-1.54,2.7,2.7,0,0,1-.14-.88c.65-1.14,1.24-2.26,1.77-3.31a2.3,2.3,0,0,1,.5-.24,2.79,2.79,0,0,1,.9-.15,2.67,2.67,0,0,1,1.17.27l.85.41Zm-80.22-46.76-28-11.22a120.54,120.54,0,0,1,100.27-58.28c-1.74.4-3.46.86-5.16,1.42-38.25,12.52-57.72,26.23-59.55,41.91C685.27,482.83,681.08,491.67,679.31,494.89Zm-1.78,3.62c-.37.86-4.93,9.46-5.47,10.26-2.49,1.41-15.92,1.7-32.65,1.47l-4.16-.07c-20.17-.37-44-1.37-59.36-2-13.35-.56-23.42-1-27.83-1-.56,0-1,0-1.41,0-3.37.13-6.86.26-7.67-.53s-.78-3.94-.76-8.32c0-.84,0-1.75,0-2.72,0-11.43-8.55-44.38-11.66-56q5.16,2,11.31,4.24L645.42,486l3.76,1.47ZM566.89,514.7A13.1,13.1,0,0,1,580,527.78v3.51a13.1,13.1,0,0,1-13.09,13.09H559a13.1,13.1,0,0,1-13.09-13.09v-3.51A13.1,13.1,0,0,1,559,514.7Zm77.31,88.73H565.35v-.65a11.54,11.54,0,0,1,11.53-11.53H686.56l70-20.5a7.78,7.78,0,0,1-5,8.26l-58.83,22-4,1.5-.69.26a10,10,0,0,1-3.55.64H644.2ZM834.41,455.75A120.43,120.43,0,1,1,651,607.43h33.5a14.2,14.2,0,0,0,5-.89l2.18-.82A86.85,86.85,0,1,0,682.74,497c1.94-3.46,6.4-12.73,8.15-27.78,1.6-13.77,20.71-26.75,56.81-38.57,13.25-4.34,28.27-3,39.28-.8q5.7,1.59,11.17,3.73c-4.17,3.27-6.7,7.55-6.7,12.23,0,10.26,12.18,18.62,27.15,18.62C829,464.39,833,461,834.41,455.75Zm-32-20.44c1.41-.87,3.33-3.95,17.7-4.12,10.31.54,11.12,6.7,11.12,15.89v.81a38.14,38.14,0,0,1-.26,4.93c-.69,5.09-3.23,7.57-12.4,7.57-12.76,0-23.15-6.56-23.15-14.62C795.45,441.67,798.13,438,802.44,435.31Zm27.9-4.94c-2-1.51-4.21-3.23-8.46-3.23-.57,0-1.14,0-1.71,0s-1,0-1.57,0a36.66,36.66,0,0,0-13.87,2.63l-1.16.33a114.78,114.78,0,0,0-16.44-4.4A124.46,124.46,0,0,0,647.6,482.16c-34.13-13.67-83.22-33.25-91.47-36.1l-2.28-.78c-3.46-1.19-8.34-2.86-13.75-4.81l-19.55-7.65,0,.12c-18.85-8-20.33-11.39-20.43-12-.4-2.4,0-3.18.18-3.4.6-.72,2.9-.73,5.13-.74,1.14,0,2.43,0,3.77-.1,5.89-.36,16.19,1.23,18.67,1.64,6.45,5.15,43.36,16.73,54.88,20.26,18,5.51,49.13,14.45,56.58,14.45a5.34,5.34,0,0,0,.86-.06c9.1-1.44,14.5-15,17.4-22.29l.33-.81c1.79-4.48,6.27-8.75,12.48-14.66,2.16-2.06,4.61-4.39,7.2-7a13.94,13.94,0,0,0,4-7.3,24.36,24.36,0,0,0,7.21,3.43,6.91,6.91,0,0,0,1.92.25c4.8,0,11.68-4,20.11-8.94,4.63-2.7,9.41-5.5,13.92-7.6,6.69-3.13,19.84-4.14,31.44-5,11.41-.88,18.89-1.55,22.6-3.37,7.08,2.29,32.57,10.37,39.49,10.37A5.54,5.54,0,0,0,819,390c30.83,4.69,56,12.28,58.47,17.58-3,4.06-27.35,24.15-34.06,25.27C835.35,434.2,832.92,432.34,830.34,430.37Z"
        />
        <path
          onClick={() => props.onFill(31)}
          fill={props.colors[31]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M421.84,539.06A11.92,11.92,0,1,0,433.75,551,11.93,11.93,0,0,0,421.84,539.06Zm0,19.83a7.92,7.92,0,1,1,7.91-7.92A7.93,7.93,0,0,1,421.84,558.89Z"
        />
        <path
          onClick={() => props.onFill(32)}
          fill={props.colors[32]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M499.8,445.22c-3.79-9.1-12.72-21.44-46.34-23.54-9.75-.61-18.57,10.61-26.3,33.34a251,251,0,0,0-7.1,25.92c-3.38-9.95-9.74-28.08-14.78-39.07A31.51,31.51,0,0,0,387.45,425a31.17,31.17,0,0,0-24.22,1.45c-14,6.69-23.85,13.92-29.87,29.29-1,2.61-4.12,10.53,25,45.73,12.16,14.68,25,28.12,28.37,31.63a39,39,0,0,0-4.3,17.86A39.4,39.4,0,1,0,458,535.39C466.39,522.65,506.24,460.67,499.8,445.22Zm-78,141.15a35.4,35.4,0,1,1,35.4-35.4A35.44,35.44,0,0,1,421.84,586.37Zm55.51-90.53c-8.4,15-17.33,29.08-21.42,35.42a39.36,39.36,0,0,0-67.11-1.75c-22.72-23.46-55.6-62.42-51.73-72.3,5.53-14.15,14.76-20.87,27.87-27.14a27.17,27.17,0,0,1,21.13-1.3,27.55,27.55,0,0,1,15.56,14.77c7.08,15.46,16.88,45.42,17,45.72l2.48,7.57,1.4-7.84A253.4,253.4,0,0,1,431,456.27c3.92-11.51,11.91-30.61,21.77-30.61h.48c24.22,1.52,37.45,8,42.9,21.08C497.5,450.09,496.91,460.91,477.35,495.84Z"
        />
      </g>
    </svg>
  );
};

Motorcycle.propTypes = {
  onFill: PropTypes.func,
  colors: PropTypes.array,
};

export default Motorcycle;
